module.exports = __webpack_public_path__ + "static/media/YB5M06_0.e040d61b.jpg";